import { a as q } from "./isArray-1rZ1P4F8.js";
import { r as S } from "./isSymbol-BWGBPKcp.js";
import { r as A } from "./memoize-DWwe-irS.js";
import { d as C } from "./isObjectLike-CWkCNISF.js";
var f, v;
function E() {
  if (v) return f;
  v = 1;
  var a = q(), n = S(), t = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, e = /^\w*$/;
  function i(r, o) {
    if (a(r))
      return !1;
    var u = typeof r;
    return u == "number" || u == "symbol" || u == "boolean" || r == null || n(r) ? !0 : e.test(r) || !t.test(r) || o != null && r in Object(o);
  }
  return f = i, f;
}
var y, b;
function G() {
  if (b) return y;
  b = 1;
  var a = A(), n = 500;
  function t(e) {
    var i = a(e, function(o) {
      return r.size === n && r.clear(), o;
    }), r = i.cache;
    return i;
  }
  return y = t, y;
}
var c, l;
function w() {
  if (l) return c;
  l = 1;
  var a = G(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, t = /\\(\\)?/g, e = a(function(i) {
    var r = [];
    return i.charCodeAt(0) === 46 && r.push(""), i.replace(n, function(o, u, s, I) {
      r.push(s ? I.replace(t, "$1") : u || o);
    }), r;
  });
  return c = e, c;
}
var m, P;
function x() {
  if (P) return m;
  P = 1;
  function a(n, t) {
    for (var e = -1, i = n == null ? 0 : n.length, r = Array(i); ++e < i; )
      r[e] = t(n[e], e, n);
    return r;
  }
  return m = a, m;
}
var p, T;
function $() {
  if (T) return p;
  T = 1;
  var a = C(), n = x(), t = q(), e = S(), i = a ? a.prototype : void 0, r = i ? i.toString : void 0;
  function o(u) {
    if (typeof u == "string")
      return u;
    if (t(u))
      return n(u, o) + "";
    if (e(u))
      return r ? r.call(u) : "";
    var s = u + "";
    return s == "0" && 1 / u == -1 / 0 ? "-0" : s;
  }
  return p = o, p;
}
var h, K;
function O() {
  if (K) return h;
  K = 1;
  var a = $();
  function n(t) {
    return t == null ? "" : a(t);
  }
  return h = n, h;
}
var _, M;
function Z() {
  if (M) return _;
  M = 1;
  var a = q(), n = E(), t = w(), e = O();
  function i(r, o) {
    return a(r) ? r : n(r, o) ? [r] : t(e(r));
  }
  return _ = i, _;
}
var d, R;
function D() {
  if (R) return d;
  R = 1;
  var a = S();
  function n(t) {
    if (typeof t == "string" || a(t))
      return t;
    var e = t + "";
    return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
  }
  return d = n, d;
}
var g, z;
function F() {
  if (z) return g;
  z = 1;
  var a = Z(), n = D();
  function t(e, i) {
    i = a(i, e);
    for (var r = 0, o = i.length; e != null && r < o; )
      e = e[n(i[r++])];
    return r && r == o ? e : void 0;
  }
  return g = t, g;
}
export {
  Z as a,
  D as b,
  x as c,
  E as d,
  w as e,
  O as f,
  F as r
};
